import { Box, styled } from '@mui/material'

export const ModalForm = styled('form')`
  width: 100%;
  height: 100%;
`
export const ModalContainer = styled(Box)`
  width: 100%;
  height: 100%;
  gap: 16px;
  display: flex;
  flex-direction: column;
  padding: 16px;
`
